export default __webpack_public_path__ + "static/circles_tabbedSection-fc9254087f5cd7e6c948efeb6638f73d.svg";